import React from 'react';
import numeral from 'numeral';
import { Link, useHistory } from 'react-router-dom';

import { getProductEncodedUrl } from '../../../../helpers';
import Button from '../../../common/Button';
import { BatchAccountingInfoBlock } from '../BatchAccountingInfoBlock';
import { useAutoTranslation } from '../../../../helpers/useAutoTranslation';
import { SUPPLIES_TABS_NAME } from '../../../../config';
import styled from '@emotion/styled';

const TableRowWrapper = styled('tr')`
  .supply-data {
    text-align: center;
  }
`;

const DesktopLayout = (props) => {
  const {
    setHoverRow,
    getYandexStoreImageMin,
    item,
    quantityEditableClass,
    handleEditItem,
    handleEditBatchOrderItem,
    itemIndex,
    getNdsValue,
    showBatchAccInfo,
    quantityFactEditable,
    ItemTD,
    hoverRow,
    currentSupply,
    quantityFactColor,
    quantityFact,
    quantityDefectiveColor,
    quantityDefective,
    isSupplyClosed,
    handleRemoveItem,
    handleEditSupplyOrder,
    defaultReserve,
    hasRelatedOrder,
    handleEditAccountingAttributes,
    activeTab,
    openEditSupplyTagModal,
    batchAccountingDataKey,
  } = props;

  const history = useHistory();

  const getCurrentSupplyItem = (supply, tab, index) => {
    return supply?.[tab]?.[index] ?? null;
  };

  const currentSupplyItem = getCurrentSupplyItem(currentSupply, activeTab, itemIndex);

  const { t } = useAutoTranslation();

  const shouldDisplayAddBatchButton =
    !isSupplyClosed && hoverRow && activeTab === SUPPLIES_TABS_NAME.PLAN;

  const shouldEnableEditingByStatus =
    ['DRAFT', 'NEW', 'READY_TO_TAKE_IN'].indexOf(currentSupply.status) !== -1;

  const shouldDisplayOrderColumn = !defaultReserve || (defaultReserve && hasRelatedOrder);

  return (
    <TableRowWrapper onMouseEnter={() => setHoverRow(true)} onMouseLeave={() => setHoverRow(false)}>
      <td className="image-td">
        {item.img ? (
          <div
            className="image-block"
            style={{ backgroundImage: `url(${getYandexStoreImageMin(item.img, 100)})` }}
          />
        ) : null}
      </td>

      {/* Номенклатура	 */}
      <td>
        <Link
          to={{
            pathname: getProductEncodedUrl(item.productId, item.variantId),
            state: { customBackLink: history.location.pathname },
          }}
          className="item-name"
        >
          {item?.shortName || item.name}
        </Link>
        {item.article ? <div className="item-article">{`Арт.: ${item.article}`}</div> : null}
        <div className="item-subname">{item.variantId}</div>
        {/*Внешний id для поставок отсутствует*/}
      </td>

      {/* Тег	*/}
      <td>
        {item.tag ? (
          <div className="item-article supply-data" onClick={openEditSupplyTagModal}>
            {item.tag}
          </div>
        ) : null}
        {/*Внешний id для поставок отсутствует*/}
      </td>

      {/* Партия */}
      <td style={{ minWidth: '100px' }}>
        {currentSupplyItem?.[batchAccountingDataKey] ? (
          <BatchAccountingInfoBlock
            itemIndex={itemIndex}
            currentSupplyItem={currentSupplyItem}
            handleEditBatchOrderItem={handleEditBatchOrderItem}
            showBatchAccInfo={showBatchAccInfo}
            activeTab={activeTab}
            shouldEnableEditingByStatus={shouldEnableEditingByStatus}
            batchAccountingDataKey={batchAccountingDataKey}
          />
        ) : (
          <>
            {shouldDisplayAddBatchButton ? (
              <button
                type="button"
                className="btn btn-link"
                style={{ padding: 0 }}
                onClick={() => handleEditBatchOrderItem(itemIndex)}
              >
                {t('Добавить')}
              </button>
            ) : null}
          </>
        )}
      </td>

      {/* Цена закупки */}
      <td
        className={
          activeTab === SUPPLIES_TABS_NAME.PLAN && shouldEnableEditingByStatus
            ? quantityEditableClass
            : ''
        }
        onClick={() => (shouldEnableEditingByStatus ? handleEditItem(itemIndex) : null)}
      >
        <div className="item-price-quantity supply-data">
          {numeral(item.price).format('0,0.00')}
        </div>
      </td>

      {/* НДС */}
      <td
        className={
          activeTab === SUPPLIES_TABS_NAME.PLAN && shouldEnableEditingByStatus
            ? quantityEditableClass
            : ''
        }
        onClick={() => (shouldEnableEditingByStatus ? handleEditItem(itemIndex) : null)}
      >
        {item.vatRate && getNdsValue(item.vatRate) ? (
          <div className="item-price-quantity supply-data">{getNdsValue(item.vatRate) + '%'}</div>
        ) : null}
      </td>

      {/* Сумма */}
      <td>
        <div className="item-price-quantity item-price-quantity-gray supply-data">
          {numeral(item.sum).format('0,0.00')}
        </div>
      </td>

      {/* Кол-во план */}
      <td
        className={
          activeTab === SUPPLIES_TABS_NAME.PLAN && shouldEnableEditingByStatus
            ? quantityEditableClass
            : ''
        }
        onClick={() => (shouldEnableEditingByStatus ? handleEditItem(itemIndex) : null)}
      >
        <div className="item-price-quantity supply-data">{item.quantity}</div>
      </td>
      {
        //  Отображаются только на вкладке 'Фактические товары':
        activeTab === SUPPLIES_TABS_NAME.FACT && (
          <>
            {/* Кол-во факт */}
            <td
              className={quantityFactEditable ? 'item-price-quantity-editable' : ''}
              style={{ minWidth: '110px' }}
            >
              {quantityFactEditable ? (
                <ItemTD
                  sectionValue={item.quantityRaw}
                  sectionName="quantityRaw"
                  placeholder={t('Кол-во')}
                  hoverRow={hoverRow}
                  currentSupply={currentSupply}
                  itemIndex={itemIndex}
                  activeTab={activeTab}
                />
              ) : (
                <div className={'item-price-quantity supply-data ' + quantityFactColor}>
                  {quantityFact || 0}
                </div>
              )}
            </td>

            {/* Кол-во брак */}
            <td>
              <div
                className={
                  'item-price-quantity supply-data ' +
                  (quantityDefective ? quantityDefectiveColor : '')
                }
              >
                {quantityDefective || 0}
              </div>
            </td>
          </>
        )
      }

      {
        //  Отображаются только на вкладке 'Плановые товары':
        activeTab === SUPPLIES_TABS_NAME.PLAN && (
          <>
            {/* Заказ */}
            {shouldDisplayOrderColumn ? (
              <td onClick={() => handleEditSupplyOrder(itemIndex, item.orderDocId)}>
                {item.orderDocId ? (
                  <div className="add-order">{item.orderDocId}</div>
                ) : (
                  <div className="add-order">+ {t('добавить заказ')}</div>
                )}
              </td>
            ) : null}

            {/* Кнопки действия */}
            <td>
              {!isSupplyClosed ? (
                <div className="d-flex">
                  <div
                    className="add-attribute"
                    onClick={() => handleEditAccountingAttributes(itemIndex)}
                  >
                    <i className="mdi mdi-barcode-scan"></i>
                  </div>
                  <div className="item-remove ml-2" onClick={() => handleRemoveItem(itemIndex)}>
                    <i className="fe-trash-2" />
                  </div>
                </div>
              ) : null}
            </td>
          </>
        )
      }
    </TableRowWrapper>
  );
};

export default DesktopLayout;
